import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { I18nProvider } from './i18n/I18nContext';
import { useEffect } from 'react'; // 1. 引入 useEffect
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import AddLog from './pages/AddLog';
import CreateProject from './pages/CreateProject';
import EditProject from './pages/EditProject';
import Profile from './pages/Profile';
import Stats from './pages/Stats';
import Login from './pages/Login';
import Register from './pages/Register';
import { Purchases, LOG_LEVEL } from '@revenuecat/purchases-capacitor';
import './index.css';

function App() {

// 3. 添加初始化 Effect
  useEffect(() => {
    const initIAP = async () => {
      // 开发环境开启日志，方便你在 Android Studio 的 Logcat 里看报错
      await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });

      // 初始化配置
      await Purchases.configure({ 
        apiKey: "goog_DRFykGcbIZxuOiHXfmnxmdmyLGU", // 填入你刚才在 RevenueCat 拿到的 Public API Key
        // 这里暂时不传 appUserID，等用户在 AuthProvider 里登录后再关联
      });
      
      console.log("RevenueCat SDK 已启动");
    };

    // 只有在真机（Capacitor 环境）下才初始化，避免 H5 预览报错
  if (typeof window !== 'undefined' && 'Capacitor' in window) {
      initIAP();
    } else {
      console.warn("⚠️ 当前处于 Web 环境，跳过支付插件初始化");
    }
  }, []);

  return (
    <HashRouter>
      <I18nProvider>
        <AuthProvider>
          <Routes>
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/add" element={
            <ProtectedRoute>
              <AddLog />
            </ProtectedRoute>
          } />
          <Route path="/create" element={
            <ProtectedRoute>
              <CreateProject />
            </ProtectedRoute>
          } />
          <Route path="/edit" element={
            <ProtectedRoute>
              <EditProject />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/stats" element={
            <ProtectedRoute>
              <Stats />
            </ProtectedRoute>
          } />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </AuthProvider>
      </I18nProvider>
    </HashRouter>
  );
}

export default App;
